<template>
  <div class="page cart">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i>
      </div>
      <div class="view-title">{{ 'cart' | lang }}</div>
    </header>
    <!--<stepper v-if="basketCountCsc > 0" :steps="steps" :step="step" />-->
    <div class="noheader">
      <div v-if="cartLoading" class="flexcentered bigger">
        {{ 'IsLoading' | lang }}
      </div>
      <div v-else-if="cartItems.length > 0">
        <ul class="results-with-icon">
          <li v-for="(opt, idx) in cart2.OrderItemWebApi" :key="`${idx}_${opt.Id}`">
            <div>
              <div class="title">{{ opt.Label }} - {{ opt.Amount / 100 | currency }}</div>
              <div class="subtitle" v-if="opt.MediaType != 'csc'" v-for="(descr, idx) in opt.Description" :key="idx">{{
                descr }}</div>

            </div>
            <div style="display:flex">
              <timed-button v-on:confirm="removeElement(opt.Id)" style="float:left;margin-right:1px" />
              <!-- <count-selector :value="opt.quantity" :min="1" v-on:input="updateQta(opt.id, opt.quantity, $event)" /> -->
            </div>
          </li>
        </ul>

        <div style="margin-top:50px;" v-if="basketCountCsc > 0">
          
          <div v-if="manifest.manageShipping==true">
            <p>{{ 'cartShippingFreeMsg' | lang }}</p>
            <div style="margin-top:20px;font-weight: bold;" class="title">{{ 'cartSelectShippingMsg' | lang }}</div>
            <div style="margin-top:5px">
              <input type="radio" :value="productCodeDefault" v-model="shippingProductCode" /> <span
                style="margin-left:5px;">{{ 'cartShippingFreeMode' | lang }}
                - {{ 0 | currency }} </span>
            </div>
            <div v-if="shippingProducts && shippingProducts.length>0" style="margin-top:5px" v-for="(p, idx) in shippingProducts">
              <input type="radio" :value="p.ProductCode" v-model="shippingProductCode" /> <span
                style="margin-left:5px;">{{ p.Title }} - {{ p.Amount / 100 | currency }} </span>
            </div>
          </div>
          <div v-else>
            <p>{{ 'cartShippingFreeMsg' | lang }}</p>

          </div>
        </div>
      </div>
      <div class="flexcentered bigger" v-else>{{ 'emptyCartMsg' | lang }}</div>
    </div>

    <footer class="doublerow">
      <!-- <div @click="invoice = !invoice" class="i-check-container" v-clickspace>
        <i class="fa fa-fw clickable" :class="{ 'fa-check-square-o': invoice, 'fa-square-o': !invoice }"></i> {{ 'SendMeInvoice' | lang }}
      </div> -->
      <div class="flexrow">
        <button v-if="false && cart2.TotalCashAmount === 0" @click="closeFreeCart"
          :disabled="cartItems.length === 0 || loading">{{ ((cart2.TotalCashAmount
            + (shippingAmount * numberShippingProducts)) / 100) | currency }}</button>
        <!-- NOTA: commissione carrello a zero non ancora confermata -->
        <button v-else @click="choosePaymentMethod"
          :disabled="cartItems.length === 0 || choosingPayment || loading || (manifest.manageShipping==true && basketCountCsc > 0 && 
          (shippingProductCode < productCodeDefault || (shippingProductCode >= productCodeDefault && !haveShipingAddress)))">{{
            'pay' | lang }} {{ ((cart2.TotalCashAmount + (shippingAmount * numberShippingProducts)) / 100) | currency
  }}</button>
        <timed-button :disabled="cartItems.length === 0 || choosingPayment || loading" v-on:confirm="_emptyCart()"
          :actiontext="dictValue('EmptyTheCart')" :confirmtext="dictValue('Confirm')"
          style="float:left;margin-right:1px" />
      </div>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
//import Stepper from '@/components/Stepper.vue';
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import paymentServices from '@/mixins/services/paymentServices'
// import CountSelector from '@/components/CountSelector'
import TimedButton from '@/components/TimedButton'
import cartServices from '@/mixins/services/cartServices'
import saleableServices from '@/mixins/services/saleableServices'
import { create } from 'vue-modal-dialogs'
import CartPaymentEndDialog from '@/dialogs/CartPaymentEndDialog' // to be removed?
import CartCreditCardSavedPaymentMethodDialog from '@/dialogs/CartCreditCardSavedPaymentMethodDialog'
import PaymentMethodChoiceDialog from '@/dialogs/PaymentMethodChoiceDialog'
import CartPaymentNewMethodDialog from '@/dialogs/CartPaymentNewMethodDialog'
import userServices from '@/mixins/services/userServices'
import warnIndirizzo from '@/dialogs/WarnIndirizzoDiSpedizione'

const warnIndirizzoDialogCreator = create(warnIndirizzo)
const cartPaymentEndDialogCreator = create(CartPaymentEndDialog) // to be removed?
const cartSavedCreditCardMethodDialogCreator = create(CartCreditCardSavedPaymentMethodDialog)
const cartPaymentNewMethodDialogCreator = create(CartPaymentNewMethodDialog)
const paymentMethodChoiceDialogCreator = create(PaymentMethodChoiceDialog)

export default {
  name: 'Cart',
  mixins: [page, databaseWrapperMixin, paymentServices, cartServices, saleableServices, userServices],
  components: { /*Stepper,*/ TimedButton },
  data() {
    return {
      loading: false,
      /*  step: 0,
        steps: [
        ],*/
      haveShipingAddres: false,
      invoice: false,
      savePayment: false,
      methods: [],
      chosen: null,
      choosingPayment: false,
      shippingProducts: [],
      productCodeNotSet: -2,
      productCodeDefault: -1, //ritiro a mano
      shippingProductCode: -2,
      shippingAmount: 0
    }
  },
  computed: {
    autoclose() {
      return this.$route.params.close === 'true' || this.$route.params.close === true
    },
    basketCountCsc() {
      var count = 0;
      if (this.cartItems && this.cartItems.length > 0) {
        for (var i = 0; i < this.cartItems.length; i++)
          if (this.cartItems[i].MediaType == 'csc' && this.cartItems[i].ItemType == 'cardOrdering')
            count++;
      }
      return count;
    },

    numberShippingProducts() {
      var number = 0;
      //  n° prodotti complementari = numero tessere inserite nel carrello / 2 + resto(numero tessere / 2)
      if (this.basketCountCsc > 0) //presupposto che il carello se contiene una tessera può contenere solo tessere
      {
        number = Math.ceil(this.basketCountCsc / 2);
      }
      return number;
    }


  },
  methods: {
    getShippingAddress() {
      var address = null;
      if (this.userProfile.profilo.AddressInfo.length == 1) {
        address = this.userProfile.profilo.AddressInfo[0];
      }
      else if (this.userProfile.profilo.AddressInfo.length > 1) {
        for (var i = 0; i < this.userProfile.profilo.AddressInfo.length; i++) {
          if (this.userProfile.profilo.AddressInfo[i].IsCustomerPrimaryAddress == false) {
            address = this.userProfile.profilo.AddressInfo[i];
          }
        }
      }
      return address;
    },
    removeElement(itemid) {
      this._removeFromCart(itemid).then(() => {
        this._getCart(true)
        // fatto già nel service
      }).catch(e => {
        console.log(e)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('RemovingFromCartError') + (e.status === 418 ? '[VAD]' : '')
        })
      })

    },

    async manageSatispay() {
      let _this = this
      let payingOrderId = this.cart2.OrderId

      var shippingProductCode = null;
      var shippingProductsToAdd = null;
      if (this.basketCountCsc > 0 && this.shippingProductCode >= 0) {
        shippingProductCode = this.shippingProductCode;
        shippingProductsToAdd = this.numberShippingProducts;
      }

      let data = await this._startSatispayPayment(this.cart2.OrderId, this.invoice)
      window.SatispayWebButton.configure({
        paymentId: data.PaymentId, // 'e49f0a7a-2dd5-4411-af8d-6164f8a2d05f',
        completed: function () {
          // executed on payment success or failure
          console.log('satispay payments completed')
          // mi salvo i dati nel solito modo
          _this.paymentRunning = { code: data.PaymentId, status: 'verifying', usertoken: _this.user.Token, orderId: payingOrderId, shippingProductCode, shippingProductsToAdd }
          // reindirizzo su endpaymentpage
          _this.goTo('/endpayment')
        }
      }).open()
      setTimeout(() => {
        this.internalBus.$emit('updateCart')
      }, 1000)
    },
    async manageCreditCard(discardPayment, ccdata) {
      var shippingProductCode = null;
      var shippingProductsToAdd = null;
      if (this.basketCountCsc > 0 && this.shippingProductCode >= 0) {
        shippingProductCode = this.shippingProductCode;
        shippingProductsToAdd = this.numberShippingProducts;
      }

      await this._startCreditCardPayment(this.cart2.OrderId, this.invoice, /* anonymousPayment */ discardPayment, ccdata, shippingProductCode, shippingProductsToAdd).then(data => {
        // console.log('payment response', data)
        this.paymentRunning = { code: data.PaymentId, status: 'verifying', usertoken: this.user.Token, orderId: this.cart2.OrderId, methodToken: ccdata ? ccdata.Token : null }
        this.$nextTick(() => {
          setTimeout(() => { location.href = data.ExternalPaymentUrl }, 50)
        })
      }).catch(e => {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : '')
        })
      })
      // let chosen = await cartSavedCreditCardMethodDialogCreator({ methods: this.methods })
      // return chosen
    },

    async choosePaymentMethod() {


      this.choosingPayment = true
      let chosen = await paymentMethodChoiceDialogCreator({ satispay: this.user.SatispayAvailable, creditcard: true, /* creditcardsaved: true, */ paypal: false })
      if (!chosen) {
        // alert('Operazione annullata!')
      } else if (chosen === 'error') {
        alert('Mmm... Nessun metodo di pagamento disponibile?')
      } else {
        if (chosen === 'creditcard') {
          if (this.user.PspAvailable && this.isFullLogged) {
            // let cc = await this.manageCreditCard()
            let cc = await cartSavedCreditCardMethodDialogCreator({ methods: this.methods })
            if (!cc) {
              this.choosingPayment = false
              return
            } else if (cc === 'save') {
              // is PSP
              let newcc = await cartPaymentNewMethodDialogCreator()
              if (!newcc) {
                this.choosingPayment = false
                return
              }
              await this.manageCreditCard(false, newcc)
            } else if (cc === 'notsave') {
              // is not PSP
              await this.manageCreditCard(true, null)
            } else {
              /* chosen = { type: chosen }
              chosen.token = cc.Token
              chosen.description = cc.Description */
              await this.manageCreditCard(false, cc)
            }
          } else {
            await this.manageCreditCard(true, null)
          }
        } else if (chosen === 'satispay') {
          // alert('Va gestito satispay')
          await this.manageSatispay()
        } else if (chosen === 'paypal') {
          alert('Paypal è il futuro, non troverai nulla qui al momento!')
        } else {
          alert('Ehm... What?')
        }
      }
      this.choosingPayment = false
    },
    async chooseCreditCardSavedMethod() {
      let chosen = await cartSavedCreditCardMethodDialogCreator({ methods: this.methods })
      if (chosen) {
        this.chosen = chosen
        this.savePayment = true
      }
    },
    async closeFreeCart() {
      this.paymentRunning = {
        orderId: this.cart2.OrderId,
        free: true
      }
      this.goTo('/endpayment', true)
    },
    async close() {
      if (this.savePayment && !this.chosen || this.chosen === 'new') {
        try {
          this.chosen = await cartPaymentNewMethodDialogCreator()
        } catch {
          return
        }
        if (!this.chosen) {
          return
        }
      }
      /* if (!this.savePayment && this.chosen && !this.chosen.Token) {
        this.chosen = 
      } */
      var shippingProductCode = null;
      var shippingProductsToAdd = null;
      if (this.basketCountCsc > 0 && this.shippingProductCode >= 0) {
        shippingProductCode = this.shippingProductCode;
        shippingProductsToAdd = this.numberShippingProducts;
      }
      console.log('sto avviando il pagamento', !this.savePayment, this.chosen, shippingProductCode, shippingProductsToAdd)
      await this._startCreditCardPayment(this.cart2.OrderId, this.invoice, /* anonymousPayment */ !this.savePayment, this.chosen, shippingProductCode, shippingProductsToAdd).then(data => {
        console.log('payment response', data)
        this.paymentRunning = { code: data.PaymentId, status: 'verifying', usertoken: this.user.Token }
        setTimeout(() => { location.href = data.ExternalPaymentUrl }, 50)
      }).catch(e => {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : '')
        })
      })
    },
    warnIndirizzo() {
      warnIndirizzoDialogCreator();
    },
    paymentDone(success) {
      this.paymentRunning = null
      this.internalBus.$emit('updateCart')
      cartPaymentEndDialogCreator({ success }).then(() => {
        console.log('success', success)
        if (success) {
          // this.dwCloseCart(true)
          /* this.internalBus.$emit('notify:success', {
            text: this.dictValue('CartBought')
          }) */
          this.goTo(this.isEticketCart ? '/mytickets' : '/', true)
        } else {
          /* this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured')
          }) */
        }
      })
    },
    prepare() {
      if (this.isFullLogged) {
        // this.user.PspAvailable = true
        this.loading = true

        if (this.basketCountCsc > 0) {
          /* this.steps = ["Selezione Tessera",
             "Caricamento Documenti",
             "Scelta Spedizione",
             "Conferma ordine"];
           this.step = 2;*/
          this.haveShipingAddress = this.getShippingAddress() != null;
        }



        this._getPaymentMethods().then(data => {
          this.methods = data
          if (this.methods.length) {
            this.chosen = this.methods[0]
            // this.savePayment = true
          }

          if (this.autoclose) {
            this.choosePaymentMethod()
          }

          if (this.manifest.manageShipping) {
            this._getSaleableProductsShipping().then(data => {
              this.loading = false
              this.shippingProducts = data;
            }).catch(err => {
              this.loading = false
            })
          } else {
            this.loading = false;
          }

        }).catch(err => {
          console.error(err)
          this.loading = false
        })
      } else {
        if (this.autoclose) {
          // this.savePayment = false
          this.choosePaymentMethod()
        }
      }
    }
  },
  beforeDestroy() {
    // clearTimeout(this.callCycleTimeout)
    clearInterval(this.interval)
    // clearInterval(this.iii)
  },
  mounted() {
    // this.buying = null
    this.shippingProductCode=this.productCodeNotSet;

    this._getCart(true).then(() => {
      /* this.iii = setInterval(() => {
        this.cart2.TotalCashAmount = 0 // REMOVE
      }, 1000) */
      this.$nextTick(() => {
        if (!this.user) {
          this.internalBus.$on('autologin:success', this.prepare)
        } else {
          this.prepare()
        }
      })
    })
  },
  watch: {

    shippingProductCode() {
      /* if (this.shippingProductCode > this.productCodeNotSet)
         this.step = 3;*/
      if (this.shippingProductCode >= 0) {
        if (!this.haveShipingAddress)
          this.warnIndirizzo();
        var found = false;
        for (var i = 0; i < this.shippingProducts.length && found == false; i++) {
          if (this.shippingProducts[i].ProductCode == this.shippingProductCode) {
            this.shippingAmount = this.shippingProducts[i].Amount;
            found = true;
          }
        }
      }
      else
        this.shippingAmount = 0;
    }
  }
}
</script>

<style lang="scss">
.cart {
  .fa-check {
    color: var(--green);
  }

  .results-with-icon button {
    padding-left: 0;
    padding-right: 0;
    width: 2rem;
  }
}
</style>
